import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
export var MigrationResult = function MigrationResult(version, data) {
  _classCallCheck(this, MigrationResult);

  this.version = version;
  this.data = data;
};